import React, { useState } from "react";
import { toast } from "sonner";
import api, { notifyError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";

/* Phase 4C — "Pembayaran Tidak Ditemukan / Batalkan Pesanan": SATU endpoint server
   (tolak klaim kanonik → P0 cancel_order, reason_code SELLER_PAYMENT_NOT_FOUND). Tidak ada dua aksi terpisah di UI. */
export function PaymentNotFoundDialog({ open, order, onClose, onDone }) {
  const [note, setNote] = useState("");
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!order) return null;
  const reset = () => { setNote(""); setChecked(false); };
  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/admin/orders/${order.id}/payment-not-found`, { note: note.trim() || null });
      toast.success(`Klaim pembayaran #${order.order_number} ditolak dan pesanan dibatalkan`);
      reset(); onDone?.();
    } catch (e) { notifyError(e); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) { reset(); onClose(); } }}>
      <DialogContent className="max-w-md" data-testid="payment-not-found-dialog">
        <DialogHeader>
          <DialogTitle>Pembayaran Tidak Ditemukan / Batalkan Pesanan #{order.order_number}</DialogTitle>
          <DialogDescription>Pastikan rekening/QRIS toko sudah diperiksa. Tindakan ini tidak dapat dibatalkan.</DialogDescription>
        </DialogHeader>
        <ul className="text-sm list-disc pl-5 space-y-1 text-[#1A1A1A]" data-testid="payment-not-found-effects">
          <li>Klaim pembayaran pelanggan akan <b>ditolak</b>.</li>
          <li>Pesanan akan <b>dibatalkan</b> dan stok dikembalikan.</li>
          <li><b>Refund tidak dibuat</b> karena pembayaran tidak terkonfirmasi.</li>
        </ul>
        <label className="flex items-start gap-2 text-sm rounded-xl bg-amber-50 border border-amber-200 p-3 text-amber-900 cursor-pointer">
          <input type="checkbox" className="mt-0.5" checked={checked} onChange={(e) => setChecked(e.target.checked)} data-testid="payment-not-found-confirm-check" />
          <span>Saya sudah memeriksa mutasi rekening/QRIS toko dan tidak menemukan pembayaran untuk pesanan ini.</span>
        </label>
        <div>
          <label className="text-sm font-medium" htmlFor="pnf-note">Catatan (opsional)</label>
          <Textarea id="pnf-note" rows={2} value={note} onChange={(e) => setNote(e.target.value)} className="rounded-xl mt-1" data-testid="payment-not-found-note" />
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" className="rounded-xl" onClick={() => { reset(); onClose(); }} disabled={busy} data-testid="payment-not-found-close">Kembali</Button>
          <Button className="rounded-xl bg-red-600 hover:bg-red-700 text-white" onClick={submit} disabled={!checked || busy} data-testid="payment-not-found-confirm">
            {busy ? "Memproses..." : "Tolak Klaim & Batalkan Pesanan"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
